export const parseIsoToDisplay = (iso?: string): string => {
    const match = iso?.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/);
    if (!match) return '';

    return [match[1], match[2], match[3]]
        .map((val) => (val ? val.padStart(2, '0') : '00'))
        .join(':');
};

export const parseDisplayToIso = (display: string): string => {
    const parts = display.split(':');

    const h = parseInt(parts[0] || '0', 10);
    const m = parseInt(parts[1] || '0', 10);
    const s = parseInt(parts[2] || '0', 10);

    if (h === 0 && m === 0 && s === 0) return '';

    const isoString = [
        h > 0 ? `${h}H` : '',
        m > 0 ? `${m}M` : '',
        s > 0 ? `${s}S` : '',
    ].join('');

    return `PT${isoString}`;
};
